import uuidV4 from 'lib/string/uuidV4Utils'

export function generateCarHireCheckoutItem(
  offer: App.CarHireOffer,
  bookingDetails: {
    pickUpDate: string;
    pickUpTime: string;
    pickUpLocation?: string;
    pickUpLocationId: string;
    pickUpSearchType?: string;
    dropOffDate: string;
    dropOffTime: string;
    dropOffLocation?: string;
    dropOffLocationId: string;
    dropOffSearchType?: string;
    ageCategory: App.CarHireDriverAgeCategory;
    age?: number;
    isPickUpAtAirport: boolean;
    selectedInsuranceType?: App.CarHireInsuranceType;
    resultsTimestamp: number;
    selectedRateOption?: App.CarHireOffer['rateOptions'][number];
    bundledOrderId?: string;
  },
): App.Checkout.CarHireItem {
  return {
    ...bookingDetails,
    itemType: 'car-hire',
    itemId: uuidV4(),
    transactionKey: uuidV4(),
    offerId: offer.id,
    offer,
    price: offer.price,
    value: offer.value,
    selectedAddons: {},
    selectedInsurance: undefined,
    selectedRateOption: {
      id: bookingDetails.selectedRateOption?.id ?? offer.rateOptions[0].id,
      idContext: bookingDetails.selectedRateOption?.idContext ?? offer.rateOptions[0].idContext,
    },
  }
}
